import { useMemo } from 'react';
import type { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { BaseSwatchesList } from '../../../../ui-components/variant/swatch/swatches-list/BaseSwatchesList';
import { TextVariant } from '../../../../ui-components/variant/text-variant/TextVariant';
import { getVariationName } from '../../../../utils/variant-helpers';
import type { ProductVariant, ProductVariantAttribute } from '../../../../bff-api/products/model';
import type { BaseSwatch } from '../../../../ui-components/variant/swatch/swatches-list/BaseSwatchesList';

export interface PdpSwatchesListProps {
    variantsList: ProductVariant[];
    variationAttributes?: ProductVariantAttribute[];
    activeId: string;
    onChange: (activeProductId: string) => void;
    size?: 'small' | 'default';
}

export const PdpSwatchesList: FC<PdpSwatchesListProps> = ({
    variantsList,
    variationAttributes,
    activeId,
    onChange,
    size = 'default',
}) => {
    const swatches = useMemo(
        () =>
            variantsList.map((variant) => ({
                color: variant.variationValues.color,
                colorName: variant.variationValues.colorName,
                productId: variant.productId,
            })) satisfies BaseSwatch[],
        [variantsList],
    );

    const variant = useMemo<ProductVariant | undefined>(
        () => variantsList.find((variantParam) => variantParam.productId === activeId),
        [variantsList, activeId],
    );
    const variationName = useMemo(
        () => getVariationName(variant?.variationValues ?? {}, variationAttributes ?? []),
        [variant, variationAttributes],
    );

    return (
        <Box display="flex" gap="8px" flexDirection="column">
            <TextVariant label="Color" value={variationName} />
            <BaseSwatchesList
                swatches={swatches}
                activeId={activeId}
                onChange={onChange}
                size={size}
            />
        </Box>
    );
};

PdpSwatchesList.defaultProps = { variationAttributes: undefined, size: 'default' };
